import { Page } from "@models/models";

export default function getMenuItemResolvedLabel(page: Page) {
  return page.name;
}
